import './styles.scss'

import { useTranslation } from 'react-i18next'

import { parseHtml } from '@/libs/utils/common'

const emptyApplications = []

const ApplicationArea = (props) => {
  const { t } = useTranslation()
  const { anchorId = '', applications = emptyApplications } = props

  const renderApplications = () =>
    applications.map((application) =>
      application
        ? (
          <div key={application} className="application-area__list-item">
            {parseHtml(application)}
          </div>
        )
        : null
    )

  return (
    <div className="application-area__wrapper pt-4 pb-4">
      <h3 id={anchorId}>{t('productDetails.applicationAreas')}</h3>
      <div className="application-area__list mt-4">{renderApplications()}</div>
    </div>
  )
}

export default ApplicationArea
